var n = function n(_n) {
  return void 0 === _n;
},
    e = function e(n) {
  return Array.isArray(n);
},
    t = function t(n) {
  return n && "number" == typeof n.size && "string" == typeof n.type && "function" == typeof n.slice;
},
    s = function s(o, i, r, f) {
  return (i = i || {}).indices = !n(i.indices) && i.indices, i.nullsAsUndefineds = !n(i.nullsAsUndefineds) && i.nullsAsUndefineds, i.booleansAsIntegers = !n(i.booleansAsIntegers) && i.booleansAsIntegers, r = r || new FormData(), n(o) ? r : (null === o ? i.nullsAsUndefineds || r.append(f, "") : "boolean" != typeof o ? e(o) ? o.length && o.forEach(function (n, e) {
    s(n, i, r, f + "[" + (i.indices ? e : "") + "]");
  }) : o instanceof Date ? r.append(f, o.toISOString()) : o !== Object(o) || function (n) {
    return t(n) && "string" == typeof n.name && ("object" == typeof n.lastModifiedDate || "number" == typeof n.lastModified);
  }(o) || t(o) ? r.append(f, o) : Object.keys(o).forEach(function (n) {
    var t = o[n];
    if (e(t)) for (; n.length > 2 && n.lastIndexOf("[]") === n.length - 2;) n = n.substring(0, n.length - 2);
    s(t, i, r, f ? f + "[" + n + "]" : n);
  }) : r.append(f, i.booleansAsIntegers ? o ? 1 : 0 : o), r);
};

export { s as objectToFormData };